export default __webpack_public_path__ + "static/media/quotes.702a0566.svg";